import React from "react";
import axios from "axios";
import { Grid, Stack } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { SystemAlert } from "@components/shared";

export default function EffortAlerts({ effortId, setShowWizard }) {
  const { data: alerts } = useQuery({
    initialData: [],
    queryKey: [`efforts${effortId}ConfigAlerts`],
    queryFn: async () =>
      axios
        .post(`/efforts/${effortId}/data-grabber/`, {
          context: `config_alerts`,
          campaign_effort_id: effortId,
        })
        .then(({ data }) => {
          return data.response;
        })
        .catch((err) => {
          throw err;
        }),
  });

  const arr = alerts
    .filter((f) => f.trigger)
    .map((m) => ({
      ...m,
      level: m.color === "yellow" ? 1 : 2,
      path: m.alt_path
        ? `/${m.alt_path}`
        : `/efforts/${effortId}${getConfigPathname(m.context)}`,
    }))
    .sort((a, b) => a.level - b.level);

  if (!arr.length) return null;

  return (
    <Stack gap={1}>
      {arr.map((alert, i) => (
        <SystemAlert
          alert={alert}
          key={i}
          onClick={() => {
            setShowWizard(false);
          }}
        />
      ))}
    </Stack>
  );
}

function getConfigPathname(context) {
  switch (context) {
    case "awards":
      return "/awards";
    case "edit":
      return "";
    case "locations":
      return "/locations";
    case "keyword":
      return "/keywords";
    case "build":
      return "/builder";
    case "verification codes":
      return "/verification";
    default:
      return "";
  }
}
